// extracted by mini-css-extract-plugin
export var chip = "_4q-0";
export var filterDropdown = "_4q-5";
export var filterItem = "_4q-6";
export var icon = "_4q-1";
export var removeButton = "_4q-3";
export var removeIcon = "_4q-4";
export var separator = "_4q-2";